import * as React from "react"
import * as Yup from "yup"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { Box, Flex } from "@chakra-ui/react"
import {
  PollsWrapper,
  PollsContainer,
  ChoicesContainer,
  PollsSubTitle,
  FormsContainer,
  ChoicesWrapper,
  ChoiceContainer,
  AddButtonContainer,
  PercentageContainer,
  InputContainer,
  CreatePollCounter,
  AddButton,
  HeaderCreatePoll,
  ScaleMod,
  VariantTextMod
} from "./polls.styled"
import { Textarea } from "../../styles/common.styled"
import { IoClose } from "react-icons/io5"
import { pollsTamplateSelector } from "../../../recoil/atoms/polls"
import { Poll, Choice } from "./polls.interfaces"
import { findThePercentage } from "../../../util"
import { SDKContext } from "../../../context/SDKContext"
import { SecondaryButton } from "../../common/buttons/secondary"
import { CommonInput } from "../../common/fields"
import { Icon } from "../../common/icons"
import { ElementTitle } from "../../common/text/element-title"
import { ConsoleLogger } from "../../../util/logger"
import { isRGBAcolor, replaceOpacity, getOpacity } from "../../../util"
import { useTranslation } from "react-i18next"
import { stringifyPollOption } from "../../../util/poll-util"

const logger = new ConsoleLogger()

interface CreatePollProps {
  poll: Poll
  isLast?: boolean
  isFirst: boolean
  defaultInputList: any
}

const _CreatePoll: React.FC<CreatePollProps> = ({
  poll,
  isLast,
  isFirst,
  defaultInputList
}) => {
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)
  const setTamplatePolls = useSetRecoilState(pollsTamplateSelector)

  const meetingClient = React.useContext(SDKContext)
  const [title, setTitle] = React.useState(poll.title)

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const [inputList, setInputList] = React.useState<Choice[]>(defaultInputList)
  const [titleErorr, setTitleErorr] = React.useState<string>("")
  const [choiceErorr, setChoiceErorr] = React.useState<string>("")
  const [choiceMaxLengthErorr, setChoiceMaxLengthErorr] =
    React.useState<string>("")
  const [sameError, setSameError] = React.useState<string>("")

  const indexErorr = React.useMemo(
    () => choiceErorr.match(/\d+/),
    [choiceErorr]
  )

  const counter = `${poll.totalResponses} ${
    poll!.totalResponses === 1 ? t("vote") : t("votes")
  }`

  const handleChangeTitle = React.useCallback(e => {
    setTitle(e.target.value)
  }, [])

  const schemaPoll = Yup.object().shape({
    question: Yup.string()
      .required(t("Please enter a question"))
      .max(1024, "max. 1024 char")
      .test("nospace", t("Text is empty"), function (value) {
        const text = value.split("")
        const haveSpace = element => element !== " "
        return text.some(haveSpace)
      }),
    options: Yup.object()
      .test(
        "checkIfWeHaveTwoAnswers",
        t("The choice cannot be empty"),
        function (value) {
          const array = Object.entries(value)

          return array[0][0] !== "" && array[1][0] !== ""
            ? true
            : this.createError({
                message: array[1][0] !== "" ? "choice[0]" : "choice[1]"
              })
        }
      )
      .nullable()
  })

  const schemaChoice = Yup.string()
    .test("nospace", t("Text is empty"), function (value) {
      const text = value.split("")
      const haveSpace = element => element !== " "
      return text.some(haveSpace)
    })
    .test("max1024char", "max. 1024 char", function (value) {
      return value.length < 1024
        ? true
        : this.createError({
            message: `${value}`
          })
    })
    .nullable()

  const handleChange = React.useCallback(
    (e, index) => {
      const { name, value } = e.target

      const list = [...inputList]

      list[index][name] = value

      setInputList(list)
    },
    [inputList]
  )

  const handleAddInput = () => {
    setInputList([...inputList, { choice: "", vote: 0 }])
  }

  const handleRemovePoll = id => {
    if (poll.isDefault) {
      setTamplatePolls({
        type: "DELETE_TAMPLATE_POLL",
        payload: { id: poll.id }
      })
    }

    if (!poll.isDefault) {
      meetingClient?.deletePoll(poll.id, poll.author.id)
    }
  }

  const handleShowPoll = () => {
    const status = poll.isVisible ? false : true
    meetingClient?.togglePoll(poll.id, status)
  }
  const handleCreatePoll = async id => {
    try {
      const filterChoices = inputList.filter(el => el.choice !== "")

      const choices = inputList.length > 2 ? filterChoices : inputList
      let count = 100
      let options = await choices.reduce(async (acc, el, index) => {
        try {
          const choice = await schemaChoice.validate(el.choice)
          const result = await acc
          count = count + 1
          const stringifyChoice = stringifyPollOption(index + 1, choice)
          result[stringifyChoice] = el.vote

          return result
        } catch (e) {
          logger.error(e.message)
          setChoiceMaxLengthErorr(e.message)
        }
      }, {})

      // wrap json object with placehoder
      /* options = meetingClient?.wrapJsonValue(options) */

      const pollData = await {
        question: title,
        options: options
      }

      const object = await schemaPoll.validate(pollData)
      meetingClient?.createPoll(object)
      setInputList(filterChoices)
      setTitleErorr("")
      setChoiceErorr("")
      setChoiceMaxLengthErorr("")
      if (poll.isDefault) {
        setTamplatePolls({
          type: "DELETE_TAMPLATE_POLL",
          payload: { id: poll.id }
        })
      }
    } catch (e) {
      logger.error(e)
      if (e.message.includes("question") || e.message.includes("1024")) {
        setTitleErorr(e.message)
      }

      if (e.message.includes("choice")) {
        setChoiceErorr(e.message)
      }

      if (e.message.includes("undefined")) {
        setSameError(e.message)
      }
    }
  }

  const handleClearPoll = id => {
    if (poll.timestamp !== "") {
      meetingClient?.deletePoll(poll.id, poll.author.id)
      if (!isFirst) {
        /*  setTamplatePolls({
          type: "CREATE_TAMPLATE_POLL",
          payload: createTamplatePoll()
        }) */
      }
    }

    if (poll.timestamp === "") {
      setTamplatePolls({
        type: "DELETE_TAMPLATE_POLL",
        payload: { id: poll.id }
      })
    }

    if (isFirst && poll.timestamp === "") {
      setInputList([
        {
          choice: "",
          vote: 0
        },
        { choice: "", vote: 0 }
      ])
      setTitle("")
    }
  }

  const isNonEmptyFields = React.useMemo<boolean>(() => {
    return Boolean(
      inputList.every(el => el.choice?.replace(/\s/g, "").length) &&
        title?.replace(/\s/g, "").length
    )
  }, [inputList, title])

  const disableButton = React.useMemo(
    () =>
      inputList[0]?.choice === "" ||
      inputList[1]?.choice === "" ||
      title === "" ||
      !isNonEmptyFields,
    [inputList, isNonEmptyFields, title]
  )

  const borderColorTitle = React.useMemo<string>(() => {
    if (titleErorr) {
      return roomStyles?.servicePanelElementWarningText ?? "red"
    }
    if (isRGBAcolor(roomStyles?.servicePanelElementBorder)) {
      return getOpacity(roomStyles?.servicePanelElementBorder) > 0.3
        ? replaceOpacity(
            roomStyles?.servicePanelElementBorder,
            getOpacity(roomStyles?.servicePanelElementBorder) - 0.3
          )
        : replaceOpacity(roomStyles?.servicePanelElementBorder, 0.1)
    }
    return `${roomStyles?.servicePanelElementBorder}b3` ?? "inherit"
  }, [
    titleErorr,
    roomStyles?.servicePanelElementBorder,
    roomStyles?.servicePanelElementWarningText
  ])

  return (
    <PollsWrapper key={poll.id} style={{ padding: "0rem 0rem 1rem 0rem" }}>
      <PollsContainer roomStyles={roomStyles}>
        <HeaderCreatePoll>
          <ElementTitle text={t("Create a poll")} />

          {!isFirst && (
            <div onClick={() => handleRemovePoll(poll.id)}>
              <Icon
                src={IoClose}
                color={
                  roomStyles?.servicePanelElementPrimaryText &&
                  roomStyles?.servicePanelElementPrimaryText
                }
                cursor={"pointer"}
                opacity={0.75}
                _hover={{ opacity: 1 }}
              />
            </div>
          )}
        </HeaderCreatePoll>
        <FormsContainer>
          <Flex pos="relative" width="100%">
            {titleErorr && (
              <Box
                right="0px"
                top="-17px"
                pos="absolute"
                fontSize="0.7rem"
                color={roomStyles?.servicePanelElementWarningText ?? "red"}
              >
                {titleErorr}
              </Box>
            )}
            <Textarea
              placeholder={t("Ask a question...")}
              borderColor={borderColorTitle}
              value={poll.timestamp !== "" ? poll.title : title}
              onChange={handleChangeTitle}
              disabled={poll.timestamp !== ""}
              id={isFirst ? `title-poll` : "poll-title"}
              autoFocus={true}
              error={titleErorr}
              roomStyles={roomStyles}
            />
          </Flex>
          <ChoicesWrapper
            style={{ marginBottom: poll.timestamp === "" && "0.5rem" }}
          >
            {poll.timestamp !== "" ? (
              <ChoicesContainer>
                {poll.choices.map((question, index) => {
                  const percentage = findThePercentage(
                    poll!.totalResponses,
                    poll.choices[index]?.vote
                  )
                  return (
                    <Box key={`${index}-${poll.id}`}>
                      <ChoiceContainer>
                        <PollsSubTitle roomStyles={roomStyles}>
                          {t("Choice")} {index + 1}
                        </PollsSubTitle>

                        <InputContainer>
                          <Flex
                            width={"222.99px"}
                            position={"relative"}
                            border={
                              roomStyles?.servicePanelElementBorder
                                ? `1px solid ${roomStyles?.servicePanelElementBorder}`
                                : "1px solid #ced4da"
                            }
                            marginRight="10px"
                            borderRadius="0.375rem"
                            height="38px"
                          >
                            <ScaleMod
                              percentage={percentage}
                              roomStyles={roomStyles}
                            ></ScaleMod>{" "}
                            <VariantTextMod roomStyles={roomStyles}>
                              {question.choice}
                            </VariantTextMod>
                          </Flex>
                          {poll.timestamp !== "" && (
                            <PercentageContainer
                              roomStyles={roomStyles}
                              isCreatedPoll={poll.timestamp !== ""}
                            >{`${Math.trunc(
                              percentage
                            )}%`}</PercentageContainer>
                          )}
                        </InputContainer>
                      </ChoiceContainer>
                    </Box>
                  )
                })}
              </ChoicesContainer>
            ) : (
              <ChoicesContainer>
                {inputList.map((question, index) => {
                  const percentage = findThePercentage(
                    poll!.totalResponses,
                    poll.choices[index]?.vote
                  )
                  const isHereErorr =
                    choiceErorr &&
                    index === +indexErorr &&
                    !choiceMaxLengthErorr
                  const isHereMaxLengthError =
                    choiceMaxLengthErorr &&
                    choiceMaxLengthErorr === question.choice
                  return (
                    <Box key={`${index}-${poll.id}`}>
                      <ChoiceContainer>
                        <PollsSubTitle roomStyles={roomStyles}>
                          {t("Choice")} {index + 1}
                        </PollsSubTitle>

                        <InputContainer>
                          <CommonInput
                            value={question.choice}
                            name="choice"
                            onChange={e => handleChange(e, index)}
                            placeholder={`${t("Choice")} ${index + 1}`}
                            isDisabled={poll.timestamp !== ""}
                            autoFocus={title.length !== 0}
                            width={poll.timestamp !== "" ? "85%" : "100%"}
                            fontSize="1rem"
                            fontWeight={400}
                            lineHeight={1.5}
                            color={
                              roomStyles.servicePanelElementPrimaryText ??
                              "#495057"
                            }
                            backgroundColor={
                              roomStyles?.servicePanelElementBackground ??
                              "#e9ecef"
                            }
                            /* border={
                              roomStyles?.servicePanelElementBorder
                                ? `2px solid ${roomStyles?.servicePanelElementBorder} !important`
                                : "2px solid #ced4da"
                            } */
                            borderRadius="0.3rem"
                            padding="0.375rem 0.75rem"
                            error={
                              isHereMaxLengthError
                                ? "max. 1024 char"
                                : isHereErorr
                                ? "The choice cannot be empty"
                                : sameError &&
                                  !choiceMaxLengthErorr &&
                                  index === 1
                                ? "Choices must be different"
                                : ""
                            }
                            _placeholder={{
                              color:
                                roomStyles.servicePanelElementPrimaryText &&
                                roomStyles.servicePanelElementPrimaryText,
                              opacity: 0.5
                            }}
                          />
                          {poll.timestamp !== "" && (
                            <PercentageContainer
                              roomStyles={roomStyles}
                              isCreatedPoll={poll.timestamp !== ""}
                            >{`${Math.trunc(
                              percentage
                            )}%`}</PercentageContainer>
                          )}
                        </InputContainer>
                      </ChoiceContainer>
                    </Box>
                  )
                })}
              </ChoicesContainer>
            )}
            {poll.timestamp === "" && (
              <AddButtonContainer>
                <AddButton
                  onClick={handleAddInput}
                  roomStyles={roomStyles}
                  disabled={
                    inputList.length >= 10 ||
                    inputList[inputList.length - 1]?.choice === ""
                  }
                >
                  {"+"}
                </AddButton>
              </AddButtonContainer>
            )}
          </ChoicesWrapper>
          {poll.timestamp !== "" && (
            <CreatePollCounter roomStyles={roomStyles}>
              {counter}
            </CreatePollCounter>
          )}
          {poll.isDefault ? (
            <SecondaryButton
              text={"Show poll"}
              onClick={handleCreatePoll}
              isDisabled={disableButton}
              marginBottom="0.4rem"
              disabled={disableButton}
            />
          ) : (
            <SecondaryButton
              text={poll.isVisible ? "Hide poll" : "Show poll"}
              onClick={handleShowPoll}
              isDisabled={disableButton}
              marginBottom="0.4rem"
              disabled={disableButton}
            />
          )}
          <SecondaryButton
            text={"Delete poll"}
            onClick={() => handleClearPoll(poll.id)}
            disabled={disableButton}
          />
        </FormsContainer>
      </PollsContainer>
    </PollsWrapper>
  )
}

export const CreatePoll = React.memo(_CreatePoll)
